<script setup lang="ts">
import { inject, Ref } from 'vue';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const isConfirm = dialogRef?.value?.options?.emits?.isConfirm;
const isClose = dialogRef?.value?.options?.emits?.isClose;
const isAlignCenter = dialogRef?.value?.data?.isAlignCenter;
const message = dialogRef?.value?.data?.message;
const subMessage = dialogRef?.value?.data?.subMessage;
const title = dialogRef?.value?.data?.title;

const selectYes = (val: boolean) => {
  isConfirm(val);
};

const selectNo = () => {
  isClose();
};
</script>
<template>
  <div class="common-modal" :class="[`pt-2 ${isAlignCenter && 'text-center'}`]">
    <div class="mb-2 font-bold text-2xl">{{ title }}</div>
    <div class="mb-2 font-bold text-primary">{{ message }}</div>
    <div class="mb-2 mt-4 font-bold text-primary">{{ subMessage }}</div>
    <Button v-if="isConfirm" id="btn-yes" class="mr-2 add-tour-btn" @click="selectYes(true)">{{ $t('management.tour.confirm.yes') }}</Button>
    <Button id="btn-no" @click="selectNo()">{{ $t('common.buttons.close') }}</Button>
  </div>
</template>
<style lang="scss" scoped>
.common-modal {
  width: min(300px, 45vw);
}
.add-tour-btn {
  background-color: #0c08e9;
}
</style>
